var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    section: true,
    'section-purpose-and-values': true,
    [`section${_vm.orderNo}`]: true
  }},[_c('a',{staticClass:"navigation-target",attrs:{"id":_vm.hash,"href":"javascript:void(0);"}}),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col col-xs-12 col-6"},[_c('div',{staticClass:"top-title"},[_c('AtomsCommonAtomTitle',{attrs:{"title":_vm.data.title,"subtitle":_vm.data.subtitle}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.data.text))])],1)]),_vm._v(" "),_c('div',{staticClass:"col col-xs-12 col-6"},[_c('MoleculesCommonMoleculeIconListWithTexts',{attrs:{"data-list":_vm.data.contents}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }